import script from "./CancelarReservas.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelarReservas.vue?vue&type=script&setup=true&lang=js"

import "./CancelarReservas.vue?vue&type=style&index=0&id=4d7656dc&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7656dc"]])

export default __exports__